import { render, staticRenderFns } from "./DuplicarProducto.vue?vue&type=template&id=77464db9&scoped=true&"
import script from "./DuplicarProducto.vue?vue&type=script&lang=js&"
export * from "./DuplicarProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77464db9",
  null
  
)

export default component.exports